/**
 * Created by Christof Sander on 22.12.2016.
 */

var utils = require('frontend-controller/lib/utils');

module.exports = {
	config: {
		// NOTE: overwrite config flags use-case dependent
		// listComponentClass: 'templates_mediaManagement_image_imageList',
		// listElementComponentClass: 'base_form_media_image_image',
		// listNewElementContainerClass: '.newImageList',
		// nrOfElementsComponentClass: 'templates_mediaManagement_image_nrOfElements',
		// getCategorizedMediaActionName: 'getCategorizedMedia'
	},

	model: {
		nrOfElements: {
			nrOfSelectedElements: 0,
			nrOfShownElements: 0,
			nrOfMatchingElements: 0,
			nrOfElements: 0
		}
	},

	methods: {
		dataDealer: function(){
			// NOTE: this function has to be overwritten by use-case ancestor and should be used to defined configs
			// this.model.imageConfig = this.getResourceRegisterContent('imageConfig') || {};
			// this.model.managementConfig = this.model.imageConfig.managementConfig || {};
		},

		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this;
			var media = self.model.mediaListComponent.getSelectedMedia();
			var nrOfElements;

			// no media selected
			if(!media || (nrOfElements = utils.collectionSize(media)) <= 0){
				return self.performAction(self.prepareAction('message', undefined, {
					messageDisplay: {
						message: 'error:imageManagement.delete.noImagesSelected'
					}
				}));
			}

			var messageBaseName = 'hint.delete.really.media';
			if(nrOfElements > 1) messageBaseName = 'hint.delete.really.mediaMultiple';

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      __(messageBaseName + '.title'),
					message:    __(messageBaseName + '.message', { nrOfElements: nrOfElements })
				}
			).then(function(context){
				if(context.decision.type === 'yes'){
					var deletionPromises = [];
					var mediaIndex;
					for(mediaIndex in media){
						deletionPromises.push(
							self.performAction(
								self.prepareAction('deleteMedia', media[mediaIndex].mediaID)
							)
						);
					}

					return utils.promise.performAll(self, deletionPromises).then(function(context){
						var selectors = [];
						for(mediaIndex in media){
							if(self.model.mediaListComponent){
								self.model.mediaListComponent.model.selectedMedia[media[mediaIndex].mediaID] = -1;
								delete self.model.mediaListComponent.model.mediaList['mediaID_' + media[mediaIndex].mediaID];
							}
							selectors.push('.' + self.config.listElementComponentClass + '[data-media-id="' + media[mediaIndex].mediaID + '"]');
						}
						self.$.find(selectors.join(',')).remove();
						if(self.$.find(self.config.listNewElementContainerClass).find('.' + self.config.listElementComponentClass + '[data-media-id]:not(.deleted)').length === 0){
							self.$.find(self.config.listNewElementContainerClass).removeClass('active');
						}
						if(self.model.mediaListComponent){
							self.model.mediaListComponent.updateNrOfElements();
						}
					});
				}
			});
		},

		showAssign: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			var self = this;
			if(buttonContext === 'tags'){
				var mediaID = (additionalData || {}).mediaID;
				var media;

				// single media assignment (inclusive preselected categories)
				if(mediaID){
					media = self.model.mediaListComponent.getMediaByID(mediaID);
					self.openTagAssignment([mediaID], media.tagsResources, 'showTagAssignmentMediaEnhanced', media);
				}
				// multi media assignment (exclusive preselected categories)
				else {
					media = self.model.mediaListComponent.getSelectedMedia();

					// no media selected
					if(!media || utils.collectionSize(media) <= 0){
						return self.performAction(self.prepareAction('message', undefined, {
							messageDisplay: {
								message: 'error:imageManagement.showAssign.tags.noImagesSelected'
							}
						}));
					} else {
						var mediaIDs = [];
						utils.forEach(media,function(media){
							mediaIDs.push(media.mediaID);
						});
						if(mediaIDs.length <= 0){
							return self.performAction(self.prepareAction('message', undefined, {
								messageDisplay: {
									message: 'error:imageManagement.showAssign.tags.noMediaIDsFound'
								}
							}));
						} else {
							return self.openTagAssignment(mediaIDs);
						}
					}
				}
			}

			return utils.promise.reject();
		},

		selectAll: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.model.mediaListComponent.selectAllMedia();
		},

		deselectAll: function(baseActionKey, buttonContext, buttonMode, actionBossComponent, additionalData){
			this.model.mediaListComponent.deselectAllMedia();
		},

		openTagAssignment: function(mediaIDs, cmsEntitiesCategories, overrideAction, media){
			var self = this;
			self.model.assignTagsToMedia = {
				mediaIDs: 				mediaIDs,
				cmsEntitiesCategories: 	cmsEntitiesCategories
			};
			self.model.tagPickerButton.open((cmsEntitiesCategories || {}).data || [], function(options){
				// submit tag assigments
				self.onTagsPicked(options);

				// submit image details if necessary
				if(options.enhancementComponent && (options.decisionOptions || {}).decisionType !== 'cancel'){
					options.enhancementComponent.submit();
				}
			}, overrideAction, media);
		},

		onTagsPicked: function(options){
			var self = this;
			var dirtyAssignedTags, dat, media, mediaID, mediaIDs, mediaIndex;
			var tagsToUpdate = [];
			if(
				(dirtyAssignedTags = ((options || {}).decisionOptions || {}).dirtyAssignedTags || {})
				&&
				(media = self.model.assignTagsToMedia || {})
				&&
				(mediaIDs = media.mediaIDs)
			){
				for(mediaIndex in mediaIDs){
					for(dat in dirtyAssignedTags){
						tagsToUpdate.push({
							type: dirtyAssignedTags[dat].type === 'delete' ? 'delete' : undefined,
							attributes: {
								entityCategoryID: 	dirtyAssignedTags[dat].entityCategoryID || dirtyAssignedTags[dat].id,

								entityID: 			mediaIDs[mediaIndex],
								entityType: 		options.categoryEntityType,
								categoryID: 		dirtyAssignedTags[dat].categoryID,
								categoryDataID: 	dirtyAssignedTags[dat].categoryDataID,
								enabled: 			dirtyAssignedTags[dat].enabled
							}
						});
					}
				}
			}

			if(tagsToUpdate.length > 0){
				self.performAction(
					self.prepareAction('updateMediaTagAssignments', undefined, undefined, {
						source: {
							submit: {
								data: {
									data: tagsToUpdate
								}
							}
						}
					})
				).then(function(){
					return self.updateMediaTagsInList(mediaIDs).then(function(){
						var statusController;
						if((statusController = getComponent('statusController'))) {
							statusController.addPanel('status.done.assigned');
						}
					});
				})
			} else {
				// silent update of media-tags (tag trl could be changed)
				self.updateMediaTagsInList(mediaIDs);
			}
		},

		updateMediaTagsInList: function(mediaIDs){
			var self = this;
			if(utils.collectionSize(mediaIDs) > 0){
				return self.performAction(
					self.prepareAction(self.config.getCategorizedMediaActionName, undefined, undefined, {
						source: {
							load: {
								resourceFilters: {
									listOfMediaIDs: mediaIDs
								}
							}
						}
					})
				).then(function(context){
					self.model.mediaListComponent.updateMediaTagsByMediaID((((context || {}).action || {}).response || {}).data || []);
					return utils.promise.resolve();
				})
			}

			return utils.promise.reject();
		}
	},

	hooks: {
		attach: function($element, options){
			var self = this;
			self.find(self.config.listComponentClass, function(mediaListComponent){
				self.model.mediaListComponent = mediaListComponent;
			});
			self.find(self.config.nrOfElementsComponentClass, function(nrOfElementsComponent){
				self.model.nrOfElementsComponent = nrOfElementsComponent;
				self.model.nrOfElementsComponent.updateNrOfElements(self.model.nrOfElements);
			});
			self.find('base_form_fields_tag-picker-button', function(tagPickerButton){
				self.model.tagPickerButton = tagPickerButton
			});
		},

		updateMediaTagsInList: function($element, options){
			this.updateMediaTagsInList(options.mediaIDs);
		},

		filterChanged: function($element, options){
			if(this.model.mediaListComponent) this.model.mediaListComponent.updateFilters(options.filters || {});
		},

		showMediaDetails: function($element, options){
			this.triggerFind('showMediaDetails', options);
		},

		updateNrOfElements: function($element, options){
			var self = this;
			self.model.nrOfElements = options.nrOfElements;
			if(self.model.nrOfElementsComponent){
				self.model.nrOfElementsComponent.updateNrOfElements(options.nrOfElements);
			}
		}
	}
};